import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { trackShipmentPOST } from "../API/TrackingApi";
import "../style/TrackingBox.css";

const TrackingBox = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const awbArray = location.state?.awbArray || [];

  const [shipments, setShipments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (awbArray.length > 0) {
      fetchAllShipments();
    } else {
      setLoading(false);
    }
  }, [awbArray]);

  const fetchAllShipments = async () => {
    try {
      setLoading(true);

      const responses = await Promise.all(
        awbArray.map((awb) => trackShipmentPOST(awb))
      );

      const results = responses
        .map((res) => {
          if (res.data?.STATUS === 1) {
            return {
              Header: res.data.Header?.[0],
              History: res.data.History || [],
            };
          }
          return null;
        })
        .filter(Boolean);

      setShipments(results);
    } catch (error) {
      console.error("Tracking Error:", error.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="tracking-container">
        <p>Loading tracking details...</p>
      </div>
    );
  }

  return (
    <div className="tracking-container">
      <button className="back-btn" onClick={() => navigate("/tracking")}>
        ← Back to Tracking
      </button>

      {shipments.length === 0 && (
        <p style={{ textAlign: "center" }}>No shipment found</p>
      )}

      {shipments.map((shipment, index) => {
        const h = shipment.Header;

        return (
          <div key={index} className="shipment-box">
            {/* ================= Shipment Header ================= */}
            <div className="shipment-header">
              Shipment Details – {h?.FWD_NO}
            </div>

            {/* ================= Shipment Summary ================= */}
            <div className="shipment-summary">
              <div><strong>Shipper:</strong> {h?.ShipperName}</div>
              <div><strong>Consignee:</strong> {h?.ConsigneeName}</div>
              <div><strong>Origin:</strong> {h?.ORIGIN}</div>
              <div><strong>Destination:</strong> {h?.Destination}</div>
              <div><strong>Pieces:</strong> {h?.PCS}</div>
              <div><strong>Weight:</strong> {h?.WT_KG} KG</div>
              <div><strong>Declared Value:</strong> ₹{h?.DEC_VALUE}</div>
              <div><strong>Network:</strong> {h?.NETWORK}</div>
              <div><strong>Status:</strong> {h?.Status}</div>
              <div><strong>Date:</strong> {h?.St_Date}</div>
              <div><strong>Time:</strong> {h?.St_Time}</div>
              <div><strong>Received By:</strong> {h?.REC_BY || "-"}</div>
            </div>

            {/* ================= History ================= */}
            <div className="shipment-header">Shipment History</div>

            <table className="tracking-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Status</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {shipment.History.length > 0 ? (
                  shipment.History.map((item, i) => (
                    <tr key={i}>
                      <td data-label="Date">{item.Status_Date}</td>
                      <td data-label="Time">{item.ST_TIME}</td>
                      <td data-label="Status" className="status">
                        {item.Status}
                      </td>
                      <td data-label="Remarks">
                        {item.POD_REM || "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" style={{ textAlign: "center" }}>
                      No history available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
};

export default TrackingBox;
